import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Spinner, Stack, Text } from "@chakra-ui/react";
import { useQuery } from "@tanstack/react-query";
import { adminGetCompanyMedicines } from "../../../api";
import MiniMedListItem from "../../../components/Medicine/MiniMedListItem";
import { colors } from "../../../styles";
import { IAdminCompanyMedicines } from "../../../types";

interface MedicinesModalProps {
    isOpen: boolean;
    onClose: () => void;
    companyId: string;
    companyName: string;
}

export default function MedicinesModal(props: MedicinesModalProps) {

    const { data: companyMedicinesData, isLoading: isCompanyMedicinesDataLoading } = useQuery<IAdminCompanyMedicines>({
        queryKey: ['adminGetCompanyMedicines', props.companyId],
        queryFn: () => adminGetCompanyMedicines({ companyId: props.companyId }),
        enabled: !!props.companyId && props.isOpen,
    });

    const medicines = companyMedicinesData?.medicines ?? [];

    return (
        <Modal motionPreset="slideInBottom" size={"4xl"} isOpen={props.isOpen} onClose={props.onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>
                    <Text color={colors.blue} fontSize="lg" fontWeight="bold">
                        {props.companyName || "-"}
                    </Text>
                    <ModalCloseButton />
                </ModalHeader>
                <ModalBody paddingTop={5}>
                    {!isCompanyMedicinesDataLoading ? (
                        <Stack
                            marginTop={5}
                            width={"100%"}
                            padding={3}
                            minHeight={"450px"}
                            maxHeight="450px"
                            overflowY="auto"
                            spacing={3}
                        >
                            <Text fontSize={14} fontWeight={700} color={colors.g1} marginBottom={3}>
                                {medicines.length}개의 약품이 연결됨
                            </Text>
                            {medicines.map((medicine) => (
                                <MiniMedListItem
                                    key={medicine.id}
                                    seller={medicine.seller ?? null}
                                    medicineImage={medicine.category === "전문의약품" ? medicine.pillImage ?? null : medicine.packImage ?? null}
                                    medicineName={medicine.nameKor ?? null}
                                    packageUnit={medicine.packageUnit ?? null}
                                    ingredientInfo={medicine.ingredientInfo ?? null}
                                />
                            ))}
                        </Stack>
                    ) : (
                        <Stack
                            marginTop={5}
                            width={"100%"}
                            padding={3}
                            height={"450px"}
                            justifyContent={"center"}
                            alignItems={"center"}
                        >
                            <Spinner color={colors.blue} />
                        </Stack>
                    )}
                </ModalBody>
            </ModalContent>
        </Modal>
    );
}
